import type { ErrorInfo, ReactNode } from 'react';
import { Component } from 'react';
import styled from '@emotion/styled';
import { EmptyState } from '../components/EmptyState';

const Wrapper = styled.div`
  height: 500px;
  display: flex;
`;

interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
}

export class MicrofrontendErrorBoundary extends Component<Props, State> {
  // eslint-disable-next-line react/state-in-constructor
  public state: State = {
    hasError: false,
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    // eslint-disable-next-line no-console
    console.error('Uncaught error:', error, errorInfo);
  }

  public render(): ReactNode {
    const { hasError } = this.state;

    if (hasError) {
      return (
        <Wrapper>
          <EmptyState
            title="Sorry, the recruitment service is currently unavailable"
            subtitle="Please try again later."
          />
        </Wrapper>
      );
    }

    const { children } = this.props;

    return children;
  }
}
